import React from 'react';

function SkeletonBar({ className = '' }: { className?: string }) {
    return (
        <div className={`animate-pulse rounded bg-gray-200 dark:bg-gray-700 ${className}`} />
    );
}

function KpiTileSkeleton() {
    return (
        <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800">
            <div className="flex items-start justify-between gap-2">
                <SkeletonBar className="h-3 w-20" />
                <SkeletonBar className="h-3 w-3 rounded-full" />
            </div>
            <SkeletonBar className="mt-3 h-8 w-16" />
        </div>
    );
}

function SectionSkeleton({ tiles = 8, withChart = false }: { tiles?: number; withChart?: boolean }) {
    return (
        <section className="rounded-xl border border-gray-200 bg-slate-50/80 dark:border-gray-700 dark:bg-gray-900/40">
            <div className="flex w-full items-center justify-between px-4 py-3">
                <SkeletonBar className="h-4 w-32" />
                <SkeletonBar className="h-3 w-3" />
            </div>
            <div className="border-t border-gray-200 px-4 py-4 dark:border-gray-700">
                <div className="mb-4 grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-6">
                    {Array.from({ length: tiles }).map((_, index) => (
                        <KpiTileSkeleton key={index} />
                    ))}
                </div>
                {withChart && <SkeletonBar className="h-64 w-full" />}
            </div>
        </section>
    );
}

function DashboardSkeleton() {
    return (
        <div
            className="flex flex-col gap-4"
            data-testid="reporting-dashboard-skeleton"
            aria-busy="true"
            aria-live="polite"
        >
            <div className="flex flex-wrap gap-2">
                {Array.from({ length: 5 }).map((_, index) => (
                    <SkeletonBar key={index} className="h-8 w-20 rounded-full" />
                ))}
            </div>

            <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
                {Array.from({ length: 6 }).map((_, index) => (
                    <KpiTileSkeleton key={index} />
                ))}
            </div>

            <SectionSkeleton tiles={8} withChart />
            <SectionSkeleton tiles={4} />
            <SectionSkeleton tiles={0} withChart />
        </div>
    );
}

export default DashboardSkeleton;
